  <ng-template class="modal-center" #rejectModal>
     <div class="modal-header bg-light justify-content-center">
      <div class="height-auto">

       <h4 class="modal-title" >
        {{ 'home.quote.Rejectoffer' | cxTranslate }}
       </h4>
       <h6 class="modal-title small text-dark text-center">{{ 'home.quote.Thisreject' | cxTranslate }}</h6>
     </div>
    </div>
    <div class="modal-footer bg-light">
      <div class="w-100">
        <button class="btn btn-block btn-danger btn-lg" type="submit" data-dismiss="modal" (click)="editQuote(productInfo)" [disabled]="disabledBtn">
          {{ 'home.quote.Ireject' | cxTranslate }}
        </button>
        <button class="btn btn-block btn-secondary btn-lg" type="submit" data-dismiss="modal" (click)="close()">
          {{ 'home.quote.Close' | cxTranslate }}
        </button>
      </div>
    </div>
</ng-template>
